import { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useLocalStore from '../../../../hooks/useLocalStore.js';
import FJHairstyleChangerLeft from '../view/FJHairstyleChangerLeft.jsx';
import { setSliceIsDraggingFileAction } from '../../../../redux/slices/FJSliceCommon.js';
import FJActionHairstyleChanger from '../../../../redux/action/FJActionHairstyleChanger.js';
import {
    HAIRSTYLE_GENDER_MALE,
    HAIRSTYLE_GENDER_FEMALE,
    NONE_GENDER,
    HAIR_STYLE_NO_CHANGE,
    HAIR_STYLE_NO_CHANGE_KEY,
    HAIR_COLOR_LIST,
    HAIR_COLOR_NO_CHANGE,
    HAIR_COLOR_NO_CHANGE_KEY,
} from '../../../../config/dataConfig/FJHairstyleChangerDataConfig.js';
import FJActionCommon from '../../../../redux/action/FJActionCommon.js';
import FJActionEditPage from '../../../../redux/action/FJActionEditPage.js';
import FJConstant from '../../../../constants/FJConstant.js';

function FJHairstyleChangerLeftContainer() {
    const [prevColor, setPrevColor] = useState(null);
    useLocalStore();
    const dispatch = useDispatch();
    const tab = useSelector(state => state.hairstyleChanger.tab);

    const hairColor = useSelector(state => state.hairstyleChanger.hairInfo.hairColor);
    const peopleImageInfo = useSelector(state => state.hairstyleChanger.peopleImageInfo);
    const isDraggingFile = useSelector(state => state.common.isDraggingFile);
    const taskStatus = useSelector(state => state.common.taskStatus);
    const isProjectLoading = useSelector(state => state.common.isProjectLoading);
    const freeNumCreation = useSelector(state => state.common.freeNumCreation);
    const creditNumber = useSelector(state => state.common.creditNumber);

    const handleUploadImg = file => {
        dispatch(FJActionHairstyleChanger.uploadImageAction(file));
    };
    const setIsDraggingFile = value => {
        dispatch(setSliceIsDraggingFileAction(value));
    };

    const handleSelectHairColor = useCallback(
        color => {
            dispatch(FJActionHairstyleChanger.setHairColorAction(color));
        },
        [dispatch],
    );

    const handleTabChange = useCallback(
        (prevIndex, index) => {
            if (index === 0) {
                prevIndex === 2 &&
                    dispatch(
                        FJActionHairstyleChanger.setHairColorAction(
                            prevColor || {
                                value: HAIR_COLOR_NO_CHANGE,
                                key: HAIR_COLOR_NO_CHANGE_KEY,
                            },
                        ),
                    );
                prevIndex === 2 && setPrevColor(hairColor);
                dispatch(FJActionHairstyleChanger.setGenderAction(HAIRSTYLE_GENDER_FEMALE));
            } else if (index === 1) {
                prevIndex === 2 &&
                    dispatch(
                        FJActionHairstyleChanger.setHairColorAction(
                            prevColor || {
                                value: HAIR_COLOR_NO_CHANGE,
                                key: HAIR_COLOR_NO_CHANGE_KEY,
                            },
                        ),
                    );
                prevIndex === 2 && setPrevColor(hairColor);
                dispatch(FJActionHairstyleChanger.setGenderAction(HAIRSTYLE_GENDER_MALE));
            } else {
                dispatch(FJActionHairstyleChanger.setGenderAction(NONE_GENDER));
                dispatch(
                    FJActionHairstyleChanger.setHairColorAction({
                        ...(prevColor || HAIR_COLOR_LIST[0]),
                    }),
                );
                dispatch(
                    FJActionHairstyleChanger.setHairstyleAction({
                        value: HAIR_STYLE_NO_CHANGE,
                        key: HAIR_STYLE_NO_CHANGE_KEY,
                    }),
                );
                setPrevColor(hairColor);
            }
            dispatch(FJActionHairstyleChanger.setTabAction(index));
        },
        [dispatch, hairColor, prevColor],
    );

    const handleGenerate = useCallback(() => {
        dispatch(FJActionCommon.setHeaderTabIndexAction(FJConstant.CREATIONS));
        dispatch(FJActionHairstyleChanger.generateAction());
    }, [dispatch]);

    useLayoutEffect(() => {
        dispatch(FJActionHairstyleChanger.initHairstyleDemonstrationAction());
    }, [dispatch]);

    useEffect(() => {
        dispatch(FJActionHairstyleChanger.initHairstylePresetDataAction());
    }, [dispatch]);

    const _openMediaLibrary = () => {
        dispatch(FJActionEditPage.openMediaLibraryAction());
    };

    return (
        <FJHairstyleChangerLeft
            hairColor={hairColor}
            onSelectHairColor={handleSelectHairColor}
            tab={tab}
            onTabChange={handleTabChange}
            setIsDraggingFile={setIsDraggingFile}
            onUploadImg={handleUploadImg}
            isDraggingFile={isDraggingFile}
            peopleImageInfo={peopleImageInfo}
            onGenerate={handleGenerate}
            taskStatus={taskStatus}
            isProjectLoading={isProjectLoading}
            freeNumCreation={freeNumCreation}
            creditNumber={creditNumber}
            openMediaLibrary={_openMediaLibrary}
        />
    );
}

export default FJHairstyleChangerLeftContainer;
